/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * state of notification:
 *   * ENABLED
 *   * DISABLED
 */
export enum ConfiguredMessageState {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED'
}
